import { c as _c } from "react/compiler-runtime";
import { Box, Separator, Flex, Heading, HStack, Image, Stack, Text, VStack } from '@chakra-ui/react';
import { CardCarousel } from '@src/components/sco/CardCarousel';
import { MobileBottomControl } from '@src/components/sco/CardCarousel/Controls/MobileBottomControl';
import { BumbleCarousel } from '@src/components/sco/SuccessLP/CustomersBlock/BumbleCarousel';
import { SocialProofFeatureCard } from '@src/components/sco/SuccessLP/SocialProofFeatureCard';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
export const CustomersBlock: React.FC<{
  containerProps?: any;
}> = props => {
  const $ = _c(113);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] !== getBreakpointValue) {
    t0 = getBreakpointValue([true, true, false, false, false]);
    $[0] = getBreakpointValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isMobile = t0;
  let t1;
  if ($[2] !== getBreakpointValue) {
    t1 = getBreakpointValue([false, false, true, false, false]);
    $[2] = getBreakpointValue;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const isTablet = t1;
  let t2;
  if ($[4] !== getBreakpointValue) {
    t2 = getBreakpointValue([10, 10, 20, 20, 20]);
    $[4] = getBreakpointValue;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== getBreakpointValue) {
    t3 = getBreakpointValue([4, 4, 10, 10, 10]);
    $[6] = getBreakpointValue;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = props.containerProps;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Separator flex="1" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== getBreakpointValue) {
    t6 = getBreakpointValue(["xl", "2xl", "3xl"]);
    $[9] = getBreakpointValue;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <Heading color="pink.fg" letterSpacing="wide" size={t6} textAlign="center" textTransform="uppercase">Customers</Heading>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Separator flex="1" />;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7) {
    t9 = <HStack align="center" gap={10} justify="center" width="full">{t5}{t7}{t8}</HStack>;
    $[14] = t7;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== getBreakpointValue) {
    t10 = getBreakpointValue(["column", "column", "row"]);
    $[16] = getBreakpointValue;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const t11 = isMobile ? 0 : 12;
  let t12;
  if ($[18] !== getBreakpointValue) {
    t12 = getBreakpointValue(["3xl", "4xl", "4xl", "5xl", "6xl"]);
    $[18] = getBreakpointValue;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== getBreakpointValue) {
    t13 = getBreakpointValue(["center", "center", "left"]);
    $[20] = getBreakpointValue;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Box as="span" bgColor="pink.fg/10" borderRadius="sm" color="colorPalette.fg" paddingX={1}>237,000</Box>;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t12 || $[24] !== t13) {
    t15 = <Heading color="red.fg" size={t12} textAlign={t13}>{"Over"}{" "}{t14}{" "}startups have launched on our platform</Heading>;
    $[23] = t12;
    $[24] = t13;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t11 || $[27] !== t15) {
    t16 = <Flex align="center" direction="column" justify="center" paddingY={t11} width="full">{t15}</Flex>;
    $[26] = t11;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  let t18;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Box bgImage="radial-gradient({colors.yellow.muted}, transparent 70%)" height="700px" position="absolute" width="700px" />;
    t18 = <BumbleCarousel />;
    $[29] = t17;
    $[30] = t18;
  } else {
    t17 = $[29];
    t18 = $[30];
  }
  const t19 = isTablet ? "auto" : "full";
  let t20;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      _light: "invert(1) saturate(0)",
      _dark: "invert(0) saturate(1)"
    };
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  let t21;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Image alt="Bumble Logo" filter={t20} height="full" objectFit="contain" opacity={0.2} src={require("@public/assets/graphics/client-logos/bumble-logo.svg").default.src} width="full" />;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  let t22;
  if ($[33] !== t19) {
    t22 = <Box height="full" left={0} position="absolute" top={0} width={t19}>{t21}</Box>;
    $[33] = t19;
    $[34] = t22;
  } else {
    t22 = $[34];
  }
  const t23 = isMobile || isTablet ? "blur(10px)" : "none";
  const t24 = isMobile || isTablet ? "blackAlpha.600" : "none";
  const t25 = isMobile || isTablet ? "md" : "none";
  const t26 = isMobile || isTablet ? 4 : 0;
  const t27 = isMobile || isTablet ? 4 : 0;
  const t28 = isTablet ? "auto" : "full";
  let t29;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = {
      _light: "invert(1) saturate(0)",
      _dark: "invert(0) saturate(1)"
    };
    $[35] = t29;
  } else {
    t29 = $[35];
  }
  let t30;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = require("@public/assets/graphics/client-logos/bumble-logo.svg");
    $[36] = t30;
  } else {
    t30 = $[36];
  }
  const t31 = isMobile || isTablet ? "80px" : "120px";
  let t32;
  if ($[37] !== t31) {
    t32 = <Image alt="Bumble Logo" filter={t29} objectFit="contain" src={t30.default.src} width={t31} />;
    $[37] = t31;
    $[38] = t32;
  } else {
    t32 = $[38];
  }
  let t33;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <Separator height="6" orientation="vertical" />;
    $[39] = t33;
  } else {
    t33 = $[39];
  }
  let t34;
  if ($[40] !== getBreakpointValue) {
    t34 = getBreakpointValue(["sm", "md", "lg"]);
    $[40] = getBreakpointValue;
    $[41] = t34;
  } else {
    t34 = $[41];
  }
  let t35;
  if ($[42] !== t34) {
    t35 = <Text color="red.fg" fontSize={t34} fontWeight={600}>Global scale; IPO on NASDAQ (BMBL)</Text>;
    $[42] = t34;
    $[43] = t35;
  } else {
    t35 = $[43];
  }
  let t36;
  if ($[44] !== t23 || $[45] !== t24 || $[46] !== t25 || $[47] !== t26 || $[48] !== t27 || $[49] !== t28 || $[50] !== t32 || $[51] !== t35) {
    t36 = <HStack align="center" backdropFilter={t23} bgColor={t24} borderRadius={t25} bottom={2} gap={3} justify="flex-end" paddingX={t26} paddingY={t27} position="absolute" right={0} width={t28} zIndex={2}>{t32}{t33}{t35}</HStack>;
    $[44] = t23;
    $[45] = t24;
    $[46] = t25;
    $[47] = t26;
    $[48] = t27;
    $[49] = t28;
    $[50] = t32;
    $[51] = t35;
    $[52] = t36;
  } else {
    t36 = $[52];
  }
  let t37;
  if ($[53] !== t22 || $[54] !== t36) {
    t37 = <Flex align="center" alignSelf="stretch" borderRadius="md" direction="column" justify="center" position="relative" width="full">{t17}{t18}{t22}{t36}</Flex>;
    $[53] = t22;
    $[54] = t36;
    $[55] = t37;
  } else {
    t37 = $[55];
  }
  let t38;
  if ($[56] !== t10 || $[57] !== t16 || $[58] !== t37) {
    t38 = <Stack align="center" direction={t10} gap={0} justify="center" width="full">{t16}{t37}</Stack>;
    $[56] = t10;
    $[57] = t16;
    $[58] = t37;
    $[59] = t38;
  } else {
    t38 = $[59];
  }
  let t39;
  if ($[60] !== isMobile || $[61] !== isTablet) {
    t39 = isMobile || isTablet ? <CardCarousel fade={false} spacing="0" visibleCards={[1]} controls={{
      top: false,
      bottom: MobileBottomControl
    }}><SocialProofFeatureCard bgImage={require("@public/assets/graphics/social/thredup-social.jpg").default.src} customerLogo={require("@public/assets/graphics/client-logos/thredup-logo.svg").default.src} title="Scaled resale market; IPO on NASDAQ (TDUP)" /><SocialProofFeatureCard bgImage={require("@public/assets/graphics/social/vevo.jpg").default.src} customerLogo={require("@public/assets/graphics/client-logos/vevo-logo.svg").default.src} title="Scaled to 400M+ monthly users" /><SocialProofFeatureCard bgImage={require("@public/assets/graphics/social/hoteltonight-social.jpg").default.src} customerLogo={require("@public/assets/graphics/client-logos/hoteltonight-logo.svg").default.src} title="Scaled and acquired by Airbnb (~$400M)" /></CardCarousel> : <HStack align="center" gap={4} justify="center" width="full"><SocialProofFeatureCard bgImage={require("@public/assets/graphics/social/thredup-social.jpg").default.src} customerLogo={require("@public/assets/graphics/client-logos/thredup-logo.svg").default.src} title="Scaled resale market; IPO on NASDAQ (TDUP)" /><SocialProofFeatureCard bgImage={require("@public/assets/graphics/social/vevo.jpg").default.src} customerLogo={require("@public/assets/graphics/client-logos/vevo-logo.svg").default.src} title="Scaled to 400M+ monthly users" /><SocialProofFeatureCard bgImage={require("@public/assets/graphics/social/hoteltonight-social.jpg").default.src} customerLogo={require("@public/assets/graphics/client-logos/hoteltonight-logo.svg").default.src} title="Scaled and acquired by Airbnb (~$400M)" /></HStack>;
    $[60] = isMobile;
    $[61] = isTablet;
    $[62] = t39;
  } else {
    t39 = $[62];
  }
  let t40;
  if ($[63] !== t38 || $[64] !== t39 || $[65] !== t9) {
    t40 = <VStack align="center" gap={10} justify="center" maxWidth="container.xl" width="full">{t9}{t38}{t39}</VStack>;
    $[63] = t38;
    $[64] = t39;
    $[65] = t9;
    $[66] = t40;
  } else {
    t40 = $[66];
  }
  let t41;
  if ($[67] !== getBreakpointValue) {
    t41 = getBreakpointValue(["column-reverse", "column-reverse", "row"]);
    $[67] = getBreakpointValue;
    $[68] = t41;
  } else {
    t41 = $[68];
  }
  const t42 = isMobile ? 0 : 20;
  let t43;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <Box bgImage="radial-gradient({colors.green.muted}, transparent 70%)" height="700px" position="absolute" width="700px" />;
    $[69] = t43;
  } else {
    t43 = $[69];
  }
  let t44;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <Image alt="Instacart" marginBottom={20} objectFit="contain" src={require("@public/assets/graphics/social/instacart-cutout.png").default.src} width="full" zIndex={2} />;
    $[70] = t44;
  } else {
    t44 = $[70];
  }
  let t45;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = {
      _light: "invert(1) saturate(0)",
      _dark: "invert(0) saturate(1)"
    };
    $[71] = t45;
  } else {
    t45 = $[71];
  }
  let t46;
  if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <Box height="full" left={0} position="absolute" top={0} width="full"><Image alt="Instacart Logo" filter={t45} height="full" objectFit="contain" opacity={0.2} src={require("@public/assets/graphics/client-logos/instacart-logo.svg").default.src} width="full" /></Box>;
    $[72] = t46;
  } else {
    t46 = $[72];
  }
  let t47;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = <Box bottom={20} display="flex" height="36px" justifyContent="center" left={-8} pointerEvents="none" position="absolute" width="full" zIndex={1}><Box bgImage="radial-gradient({colors.blackAlpha.700}, transparent 100%)" borderRadius="full" filter="blur(8px)" height="100%" width="80%" /></Box>;
    $[73] = t47;
  } else {
    t47 = $[73];
  }
  const t48 = isMobile || isTablet ? "blur(10px)" : "none";
  const t49 = isMobile || isTablet ? "blackAlpha.600" : "none";
  const t50 = isMobile || isTablet ? "md" : "none";
  const t51 = isMobile || isTablet ? 2 : 0;
  const t52 = isMobile || isTablet ? 4 : 0;
  let t53;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = {
      _light: "invert(1) saturate(0)",
      _dark: "invert(0) saturate(1)"
    };
    $[74] = t53;
  } else {
    t53 = $[74];
  }
  let t54;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t54 = require("@public/assets/graphics/client-logos/instacart-logo.svg");
    $[75] = t54;
  } else {
    t54 = $[75];
  }
  const t55 = isMobile || isTablet ? "80px" : "140px";
  let t56;
  if ($[76] !== t55) {
    t56 = <Image alt="Instacart Logo" filter={t53} objectFit="contain" src={t54.default.src} width={t55} />;
    $[76] = t55;
    $[77] = t56;
  } else {
    t56 = $[77];
  }
  let t57;
  if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
    t57 = <Separator height="6" orientation="vertical" />;
    $[78] = t57;
  } else {
    t57 = $[78];
  }
  let t58;
  if ($[79] !== getBreakpointValue) {
    t58 = getBreakpointValue(["sm", "md", "lg"]);
    $[79] = getBreakpointValue;
    $[80] = t58;
  } else {
    t58 = $[80];
  }
  let t59;
  if ($[81] !== t58) {
    t59 = <Text color="red.fg" fontSize={t58} fontWeight={600}>Served 10M+ customers; #1 US grocery delivery platform</Text>;
    $[81] = t58;
    $[82] = t59;
  } else {
    t59 = $[82];
  }
  let t60;
  if ($[83] !== t48 || $[84] !== t49 || $[85] !== t50 || $[86] !== t51 || $[87] !== t52 || $[88] !== t56 || $[89] !== t59) {
    t60 = <Flex align="center" alignSelf="stretch" borderRadius="md" direction="column" justify="center" position="relative" width="full">{t43}{t44}{t46}{t47}<HStack align="center" backdropFilter={t48} bgColor={t49} borderRadius={t50} bottom={2} gap={3} justify="flex-end" marginBottom={t51} paddingX={t52} paddingY={4} position="absolute" right={0} width="full" zIndex={2}>{t56}{t57}{t59}</HStack></Flex>;
    $[83] = t48;
    $[84] = t49;
    $[85] = t50;
    $[86] = t51;
    $[87] = t52;
    $[88] = t56;
    $[89] = t59;
    $[90] = t60;
  } else {
    t60 = $[90];
  }
  const t61 = isMobile ? 0 : 12;
  let t62;
  if ($[91] !== getBreakpointValue) {
    t62 = getBreakpointValue(["3xl", "4xl", "4xl", "5xl", "6xl"]);
    $[91] = getBreakpointValue;
    $[92] = t62;
  } else {
    t62 = $[92];
  }
  let t63;
  if ($[93] !== getBreakpointValue) {
    t63 = getBreakpointValue(["center", "center", "left"]);
    $[93] = getBreakpointValue;
    $[94] = t63;
  } else {
    t63 = $[94];
  }
  let t64;
  if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
    t64 = <Box as="span" bgColor="pink.fg/10" borderRadius="sm" color="colorPalette.fg" paddingX={1}>23 million</Box>;
    $[95] = t64;
  } else {
    t64 = $[95];
  }
  let t65;
  if ($[96] !== t62 || $[97] !== t63) {
    t65 = <Heading color="red.fg" size={t62} textAlign={t63}>{"And we've helped them find"}{" "}{t64}{" "}first customers</Heading>;
    $[96] = t62;
    $[97] = t63;
    $[98] = t65;
  } else {
    t65 = $[98];
  }
  let t66;
  if ($[99] !== t61 || $[100] !== t65) {
    t66 = <Flex align="center" direction="column" justify="center" paddingY={t61} width="full">{t65}</Flex>;
    $[99] = t61;
    $[100] = t65;
    $[101] = t66;
  } else {
    t66 = $[101];
  }
  let t67;
  if ($[102] !== t41 || $[103] !== t42 || $[104] !== t60 || $[105] !== t66) {
    t67 = <VStack align="start" gap={0} justify="center" maxWidth="container.xl" width="full"><Stack align="center" direction={t41} gap={t42} justify="center" width="full">{t60}{t66}</Stack></VStack>;
    $[102] = t41;
    $[103] = t42;
    $[104] = t60;
    $[105] = t66;
    $[106] = t67;
  } else {
    t67 = $[106];
  }
  let t68;
  if ($[107] !== props.containerProps || $[108] !== t2 || $[109] !== t3 || $[110] !== t40 || $[111] !== t67) {
    t68 = <VStack align="center" bgImage="linear-gradient({colors.pink.muted}, transparent, transparent, {colors.pink.muted})" borderRadius="3xl" boxShadow="inset 0 1px 0 rgba(255, 255, 255, 0.2)" gap={t2} height="full" justify="stretch" overflow="hidden" padding={t3} width="full" {...t4}>{t40}{t67}</VStack>;
    $[107] = props.containerProps;
    $[108] = t2;
    $[109] = t3;
    $[110] = t40;
    $[111] = t67;
    $[112] = t68;
  } else {
    t68 = $[112];
  }
  return t68;
};